import { state as listState } from './list';

export const states = [listState.AgeGroupsListState];
